import { render } from "./EventContributorsList.vue?vue&type=template&id=decb9a4c"
import script from "./EventContributorsList.vue?vue&type=script&lang=js"
export * from "./EventContributorsList.vue?vue&type=script&lang=js"

import "./EventContributorsList.vue?vue&type=style&index=0&id=decb9a4c&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__